import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { browserHistory } from 'react-router';

import Loader from '../../common/Loader';
import ProgramCard from '../ProgramCard';
import Placeholder from '../../common/EmptyState/Content';
import { currentLocationSelector } from '../../../redux/common/selectors';
import { PROGRAM_TYPE, PROGRAM_COUNTERS } from '../../../constants/programs';

import styles from '../index.styl';

export function useProgramTabs({
  user,
  sending,
  programs,
  counters,
  formatMessage,
  deepLinkProgramTab,
}) {
  const [active, setActive] = useState(PROGRAM_TYPE.ACTIVE);
  const pathname = useSelector(currentLocationSelector);

  useEffect(() => {
    if (deepLinkProgramTab) {
      setActive(deepLinkProgramTab);
      browserHistory.push({ pathname, search: '' });
    }
  }, [deepLinkProgramTab]);

  const list = useMemo(
    () =>
      Object.values(PROGRAM_TYPE).map((tab, id) => ({
        id,
        tab,
        label: `programs.tabs.${tab}`,
        counter: counters[PROGRAM_COUNTERS[tab]] || 0,
      })),
    [counters],
  );

  const render = useCallback(
    tab => {
      if (sending) return <Loader />;

      return programs.length ? (
        programs.map(program => (
          <ProgramCard program={program} key={program.id} />
        ))
      ) : (
        <Placeholder
          icon="programs-empty"
          className={styles.placeholder}
          text={formatMessage(
            { id: `programs.tabs.${tab}.placeholder` },
            { name: user },
          )}
        />
      );
    },
    [user, sending, programs],
  );

  return { list, render, active, setActive };
}



// WEBPACK FOOTER //
// ./src/components/Programs/hooks/useProgramTabs.jsx